import { Box } from '@mui/material';
import { generateOptionId, sortOptionsByType } from '../StationFilterUtils';
import { StationFilterOption } from '../types';
import { StationFilterChip } from './StationFilterChip';

export interface StationFilterChipsListProps {
  values: StationFilterOption[];
  size?: 'small' | 'medium' | 'large';
  spacing?: number;
  readonly?: boolean;
}

export const StationFilterChipsList = ({
  values,
  size = 'medium',
  spacing = 1,
  readonly = true,
}: StationFilterChipsListProps) => {
  if (values.length === 0) {
    return null;
  }

  // Sort the values by type priority
  const sortedValues = sortOptionsByType(values);

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: spacing,
        alignItems: 'flex-start',
      }}
    >
      {sortedValues.map((option) => (
        <StationFilterChip
          key={generateOptionId(option)}
          option={option}
          size={size}
          readonly={readonly}
        />
      ))}
    </Box>
  );
};
